module.exports = __webpack_public_path__ + "img/page-not-found.6e6596b7.svg";